import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ASIAN_BASE_URL, GAMES_BASE_URL } from 'constants/locations';
import { getAccountNavigationSidebarItems, RESPONSIBLE_BETTING_MENU_ITEM } from 'constants/navigation';
import { getIsResponsibleBettingMenuEnabled } from 'redux/modules/appConfigs/selectors';

import DesktopNavigationMyAccountItem from '../DesktopNavigationMyAccountItem';

import styles from './styles.module.scss';

const DesktopNavigationMyAccount = ({ isTitle }: { isTitle?: boolean }) => {
  const { t } = useTranslation();

  const showResponsibleBetting = useSelector(getIsResponsibleBettingMenuEnabled);

  const isGamePage = location.pathname.includes(GAMES_BASE_URL);
  const isAsianPage = location.pathname.includes(ASIAN_BASE_URL);

  const accountNavigation = showResponsibleBetting
    ? [...getAccountNavigationSidebarItems({ isAsianViewPage: isAsianPage, isGamePage }), RESPONSIBLE_BETTING_MENU_ITEM]
    : getAccountNavigationSidebarItems({ isAsianViewPage: isAsianPage, isGamePage });

  return (
    <div className={styles.navigationContainer}>
      {isTitle && <h4 className={styles.title}>{t('account.settings.activity.title')}</h4>}
      <nav className={styles.navigationList}>
        {accountNavigation.map(item => (
          <DesktopNavigationMyAccountItem key={item.code} item={item} />
        ))}
      </nav>
    </div>
  );
};

export default DesktopNavigationMyAccount;
